import React, { useState } from 'react';
import './AboutPage.css'

/* Components */
import HeaderPage from '../../components/Header/HeaderPage';
import Footer from '../../components/Footer/Footer';
import ParticleBackground from "../../components/ParticlesBg/ParticleBackground";
import ScrollToTop from '../../components/ScrollToTop/ScrollToTop';
import cv from '../../cv/cv.pdf';

/* Multi idioma */
import { FormattedMessage } from 'react-intl';

/* Img */
import imgabout from '../../img/home.png';

const About = () => {
  const [showAllSkills, setShowAllSkills] = useState(false);
  const skillsPerView = 8;

  function readMore() {
    let btnHide = document.querySelector("#btn-hide");
    let parrafoActive = document.querySelector(".parrafo-active");

    parrafoActive.classList.toggle("show");

    if (parrafoActive.classList.contains("show")) {
      btnHide.innerHTML = "↑ Show Less";
    } else {
      btnHide.innerHTML = "↓ Read More";
    }
  }

  // Skills data organized by category
  const skillCategories = [
    {
      title: "Programming Languages",
      skills: [
        { 
          name: "C++", 
          description: "High-performance programming for system and application development", 
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-plain.svg" 
        },
        { 
          name: "Python", 
          description: "Data science, FastAPI backend development, and automation scripting", 
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" 
        },
        { 
          name: "JavaScript/TypeScript", 
          description: "React.js, Next.js, Expo, and modern frontend development", 
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" 
        },
        { 
          name: "HTML & CSS", 
          description: "Semantic structure, responsive design, and Tailwind CSS", 
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg" 
        },
        { 
          name: "SQL", 
          description: "Database design, optimization, and complex query development", 
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg" 
        }
      ]
    },
    {
      title: "Frontend Development",
      skills: [
        { 
          name: "React.js", 
          description: "Component architecture, hooks, state management, and routing", 
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" 
        },
        { 
          name: "React Native/Expo", 
          description: "Cross-platform mobile development with Firebase integration", 
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" 
        },
        { 
          name: "Next.js", 
          description: "Server-side rendering, static site generation, and API routes", 
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg" 
        },
        { 
          name: "Tailwind CSS", 
          description: "Utility-first CSS framework for rapid UI development", 
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-plain.svg" 
        }
      ]
    },
    {
      title: "AI & Data Science",
      skills: [
        { 
          name: "TensorFlow.js", 
          description: "Machine learning in the browser using JavaScript", 
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tensorflow/tensorflow-original.svg" 
        },
        { 
          name: "Pandas", 
          description: "Data manipulation and analysis using dataframes", 
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pandas/pandas-original.svg" 
        },
        { 
          name: "NumPy", 
          description: "Numerical computing and array operations", 
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/numpy/numpy-original.svg" 
        },
        { 
          name: "Scikit-learn", 
          description: "Machine learning algorithms for classification and regression", 
          icon: "https://upload.wikimedia.org/wikipedia/commons/0/05/Scikit_learn_logo_small.svg" 
        }
      ]
    },
    {
      title: "Backend Development",
      skills: [
        { 
          name: "FastAPI", 
          description: "High-performance RESTful API development with Python", 
          icon: "https://fastapi.tiangolo.com/img/logo-margin/logo-teal.png" 
        },
        { 
          name: "Django", 
          description: "Full-stack web framework with MVC architecture", 
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/django/django-plain.svg" 
        },
        { 
          name: "Firebase", 
          description: "Authentication, Firestore database, and cloud functions", 
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg" 
        },
        { 
          name: "REST APIs", 
          description: "Designing and building scalable API architectures", 
          icon: "https://cdn-icons-png.flaticon.com/512/2452/2452491.png" 
        }
      ]
    },
    {
      title: "Databases & Cloud",
      skills: [
        { 
          name: "MongoDB", 
          description: "NoSQL database management and aggregation pipelines", 
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg" 
        },
        { 
          name: "MySQL", 
          description: "Relational database design and optimization", 
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg" 
        },
        { 
          name: "PostgreSQL", 
          description: "Advanced relational database with JSON support", 
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg" 
        },
        { 
          name: "AWS", 
          description: "Cloud computing services for deployment and scaling", 
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original.svg" 
        }
      ]
    }
  ];

  // Flatten all skills for the grid view
  const allSkills = skillCategories.flatMap(category => category.skills);
  const displayedSkills = showAllSkills ? allSkills : allSkills.slice(0, skillsPerView);

  return (
    <div>
      <HeaderPage />
      <ParticleBackground />
      <main>
        <section className="sobre-mi-seccion" id="sobre-mi">
          <div className="about-hero">
            <div className="hero-content">
              <h1 className="hero-title">
                <FormattedMessage id='about-hero-title' defaultMessage='Crafting Digital Experiences with Code & Creativity' />
              </h1>
              <p className="hero-subtitle">
                <FormattedMessage 
                  id='about-hero-subtitle' 
                  defaultMessage='Full-stack developer passionate about building innovative solutions that bridge technology and user needs' 
                />
              </p>
            </div>
          </div>

          <div className="sobre-mi-container">
            <div className="image-container-modern">
              <div className="profile-frame">
                <img src={imgabout} alt="Arun Singh" className="profile-img-modern" />
                <div className="frame-decoration"></div>
                <div className="tech-badges">
                  <span className="tech-badge">React</span>
                  <span className="tech-badge">Python</span>
                  <span className="tech-badge">AI/ML</span>
                </div>
              </div>
              
              <a href={cv} target="_blank" rel="noopener noreferrer" download="Arun_Singh_CV.pdf" className="btn-download-cv">
                <i className="fas fa-download"></i>
                <FormattedMessage id='btn-cv' defaultMessage='Download CV' />
              </a>
            </div>
            
            <div className="sobre-mi-info">
              <div className="section-tag">
                <FormattedMessage id='about-tag' defaultMessage='About Me' />
              </div>
              
              <h2 className="info-title">
                <FormattedMessage id='about-title' defaultMessage='Turning Ideas Into Digital Reality' />
              </h2>
              
              <p className="info-intro">
                <FormattedMessage
                  id='about-info-1'
                  defaultMessage="I'm a passionate full-stack developer with expertise in creating responsive web applications and intelligent systems. My journey began at RIMT University, Punjab, where I developed a strong foundation in both computer science fundamentals and practical software development."
                />
              </p>

              <div className="hide parrafo-active">
                <p>
                  <FormattedMessage
                    id='about-info-2'
                    defaultMessage='My projects span from AI-powered applications to responsive web platforms, each designed with a focus on performance and user experience. I believe in writing clean, maintainable code and constantly exploring new technologies to enhance my skill set.'
                  />
                </p>

                <div className="philosophy-section">
                  <h3>My Development Philosophy</h3>
                  <div className="philosophy-grid">
                    <div className="philosophy-item">
                      <i className="fas fa-code"></i>
                      <h4>Clean Code</h4>
                      <p>Writing maintainable, efficient, and well-documented code</p>
                    </div>
                    <div className="philosophy-item">
                      <i className="fas fa-users"></i>
                      <h4>User-Centric</h4>
                      <p>Designing with the end-user's experience as the priority</p>
                    </div>
                    <div className="philosophy-item">
                      <i className="fas fa-rocket"></i>
                      <h4>Performance</h4>
                      <p>Optimizing applications for speed and efficiency</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="btn-info">
                <button className="custom-btn btn-read-more" id="btn-hide" onClick={readMore}>
                  <span>↓ Read More</span>
                </button>
              </div>
            </div>
          </div>

          <div className="skill-seccion">
            <div className="section-header-center">
              <div className="section-tag">Skills</div>
              <h2 className="section-title">Technologies I Work With</h2>
              <p className="section-subtitle">Continuously expanding my toolkit to deliver cutting-edge solutions</p>
            </div>
            
            {/* Skills Grid View */}
            <div className="skills-grid-container">
              <div className="skills-grid">
                {displayedSkills.map((skill, index) => (
                  <div key={index} className="skill-card" data-aos="fade-up" data-aos-delay={index * 50}>
                    <div className="skill-icon-container">
                      <img src={skill.icon} alt={skill.name} className="skill-icon" />
                    </div>
                    <h3 className="skill-title">{skill.name}</h3>
                    <p className="skill-description">{skill.description}</p>
                  </div>
                ))}
              </div>
              
              {allSkills.length > skillsPerView && (
                <div className="show-more-container">
                  <button 
                    className="show-more-btn" 
                    onClick={() => setShowAllSkills(!showAllSkills)}
                  >
                    {showAllSkills ? 'Show Less' : `View All Skills (${allSkills.length})`}
                  </button>
                </div>
              )}
            </div>
            
            {/* Skills by Category */}
            <div className="skills-by-category">
              {skillCategories.map((category, index) => (
                <div key={index} className="skill-category">
                  <h2 className="category-title">{category.title}</h2>
                  <div className="category-skills">
                    {category.skills.map((skill, skillIndex) => (
                      <div key={skillIndex} className="category-skill-item">
                        <img src={skill.icon} alt={skill.name} className="category-skill-icon" />
                        <span className="category-skill-name">{skill.name}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <ScrollToTop />
      <Footer />
    </div>
  )
}
export default About;